export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3030',
  graphqlUrl:
    import.meta.env.VITE_GRAPHQL_URL ?? 'http://localhost:3030/graphql',
} as const
